//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'owner-workOrders',
    props: {
        memberId: {
            type: Number,
            required: true
        }
    },
    data() {
        var vm = this;
        return {
            columns: [
                {
                    type: 'index',
                    width: 60,
                    fixed: 'left',
                    align: 'center'
                },
                {
                    title: '工单单号', align: 'center', width: 170, fixed: 'left',
                    key: 'workOrderNo',
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let code = row.workOrderNo;
                        if (code == null || code === '') {
                            code = '未填写';
                        }
                        actions.push(
                            h('a', {
                                on: {
                                    click: function() {
                                        vm.showDetail(row);
                                    }
                                }
                            }, code)
                        );
                        return actions;
                    }
                },
                {
                    title: '工单类型',
                    align: 'center',
                    key: 'workOrderTypeStr',
                    minWidth: 100
                },
                {
                    title: '创建时间', align: 'center', key: 'createTimeStr', minWidth: 150
                },
                {
                    title: '联系人', align: 'center', key: 'name', minWidth: 100
                },
                {
                    title: '联系电话', align: 'center', key: 'mobile', minWidth: 130
                },
                {
                    title: '内容', align: 'center', key: 'content', minWidth: 160,
                    render(h, params) {
                        let content = '';
                        let row = params.row;
                        if (row.content != null && row.content != '') {
                            if (row.content.length > 20) {
                                content = row.content.substring(1, 20) + '...';
                            } else {
                                content = row.content;
                            }
                        }
                        return h('Poptip', {
                            props: {
                                trigger: 'hover',
                                // title:' 11',
                                placement: 'bottom',
                                transfer: true
                            }
                        }, [
                            h('div', content),
                            h('div', {
                                slot: 'content',
                                style: {
                                    // width: "300px",
                                    // height: "100px",
                                    overflow: 'hidden',
                                    whiteSpace: 'normal'
                                }
                            }, [
                                h('div', row.content)
                            ])
                        ]);
                    }
                },
                {
                    title: '开始处理时间', align: 'center', key: 'clStarTimeStr', minWidth: 160
                },
                {
                    title: '处理完成时间', align: 'center', key: 'clEndTimeStr', minWidth: 150
                },
                // {
                //     title: '退单次数',
                //     align: 'center', width: 100
                // },
                {
                    title: '工单状态', align: 'center', key: 'statusStr', minWidth: 160
                }
            ],
            searchInput: {},
            loading: false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            list: [],
            pageSizeOpts: [10, 20, 30, 40, 50]
        };
    },
    computed: {},
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            if (!parseInt(this.memberId) > 0) {
                return;
            }
            this.searchInput.memberId = parseInt(this.memberId);
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/WorkOrder/SearchWorkOrders', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        showDetail(row) {
            this.$router.push('/workOrderDetail/' + row.id);
        }
    },
    created() {
        this.getPage();
    },
    watch: {
        memberId(val, oldVal) {
            if (parseInt(val) > 0) {
                this.currentPage = 1;
                this.getPage();
            }
        }
    }
};
